import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import strings from './UI/Utils/LocalizedStrings';

// Set <html lang> dynamically based on the browser locale and supported languages.
// If the browser language matches a supported language, suppress Chrome auto-translate
// (since the content is already in the user's language). Otherwise, fall back to English
// and allow Chrome to offer translation.
const supportedLanguages = strings.getAvailableLanguages();
const browserBaseLanguage = navigator.language.split("-")[0].toLowerCase();
const isLanguageSupported = supportedLanguages.includes(browserBaseLanguage);
const resolvedLanguage = isLanguageSupported ? browserBaseLanguage : "en";

document.documentElement.lang = resolvedLanguage;
if (isLanguageSupported) {
  document.documentElement.setAttribute("translate", "no");
  const meta = document.createElement("meta");
  meta.name = "google";
  meta.content = "notranslate";
  document.head.appendChild(meta);
}

ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
